import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  viewBox: "0 0 100 100"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "50",
      cy: "50",
      r: "40",
      stroke: "silver",
      "stroke-width": "10",
      fill: "none"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "50",
      cy: "50",
      r: "40",
      stroke: "white",
      "stroke-width": "8",
      "stroke-linecap": "round",
      fill: "none"
    }, [
      _createElementVNode("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        repeatCount: "indefinite",
        dur: "1.3s",
        values: "0 50 50;180 50 50;720 50 50",
        keyTimes: "0;0.5;1"
      }),
      _createElementVNode("animate", {
        attributeName: "stroke-dasharray",
        repeatCount: "indefinite",
        dur: "1.3s",
        values: "18.84955592153876 200.64600329384882;94.2477796076938 94.24777960769377;18.84955592153876 200.64600329384882",
        keyTimes: "0;0.5;1"
      })
    ], -1)
  ]))]))
}
export default { render: render }